import tw, { styled } from 'twin.macro';

const RoundedBlock = styled.div`
  ${tw`border-gray-200 border rounded-lg md:rounded-xl overflow-hidden p-5 md:px-7 md:py-6`};
`;

export default RoundedBlock;
